import reducer from './reducers'
import name from './name'
import api from './api'

export { reducer, name, api }
